var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"btn fab",attrs:{"to":{ name: 'Cart' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("shopping_cart")]),_c('div',{staticClass:"badge"},[_c('span',[_vm._v(_vm._s(_vm.quantity))])])])}
var staticRenderFns = []

export { render, staticRenderFns }